import { useState } from "react";
import { useSchemaForm } from "@/components/form";
import { notify } from "@/shared/notification";
import { useAddDocumentoElectronicoMutation } from "@/features/facturacion-electronica/api/add-documento-electronico";
import { NotaCreditoForm, notaCreditoFormSchema } from "@/features/facturacion-electronica/components/nota-credito-form";
import { useEmisorConfig } from "@/features/facturacion-electronica/hooks/use-emisor-config";
import { buildNotaCreditoRequest } from "@/features/facturacion-electronica/utils/de-request-builder";
import { DEPageLayout } from "@/features/facturacion-electronica/components/de-page-layout";
import { DE_SUCCESS_MESSAGES } from "@/features/facturacion-electronica/utils/de-form-utils";
import { Cliente } from "@/shared/types/cliente";
import useKudePrinter from "@/features/facturacion-electronica/hooks/use-kude-printer";

export default function NuevaNotaCreditoPage() {
    return (
        <DEPageLayout title="Nueva Nota de Crédito">
            <AddNotaCreditoForm />
        </DEPageLayout>
    );
}

function AddNotaCreditoForm() {
    const mutation = useAddDocumentoElectronicoMutation();
    const { config } = useEmisorConfig();
    const [cliente, setCliente] = useState<Cliente | null>(null);
    const [cdcLoaded, setCdcLoaded] = useState(false);
    const { printKude, Printer } = useKudePrinter();

    const form = useSchemaForm({
        schema: notaCreditoFormSchema,
        onSubmit: async ({ value, formApi }) => {
            const deRequest = buildNotaCreditoRequest(value, config!);
            const result = await mutation.mutateAsync(deRequest);
            notify(DE_SUCCESS_MESSAGES.notaCredito);

            await printKude({ documentTitle: `KUDE N°${result.docNumDE}`, kudeBase64: result.kuDEBase64, deId: result.idDE });

            // Reset form
            formApi.reset();
            setCliente(null);
            setCdcLoaded(false);
            formApi.setFieldValue("clienteId", "");
            formApi.setFieldValue("items", []);
            formApi.setFieldValue("motivoEmision", "1");
            formApi.setFieldValue("pagos", []);
            formApi.setFieldValue("tipoDocumentoAsociado", "1");
        },
    });

    return (
        <>
            <NotaCreditoForm
                form={form}
                onClienteChange={setCliente}
                cliente={cliente}
                cdcLoaded={cdcLoaded}
                setCdcLoaded={setCdcLoaded}
                flex={1}
            />
            <Printer />
        </>
    );
}
